import Vue from "vue";
import router from "@/router";
import axios from "axios";
import VueAxios from "vue-axios";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

Vue.use(VueAxios, axios);

const OAUTH_SERVER_URL = process.env.VUE_APP_OAUTH_SERVER_URL;
const CLIENT_ID = process.env.VUE_APP_OAUTH_CLIENT_ID;
const REDIRECT_URI = `${window.location.origin}/auth/callback`;
const TOKEN_ENDPOINT = `${OAUTH_SERVER_URL}/oauth/token`;
const AUTHORIZE_ENDPOINT = `${OAUTH_SERVER_URL}/oauth/authorize`;
const AUTH_SERVER_HOME_PAGE = `${OAUTH_SERVER_URL}`;

function generateCodeVerifier() {
  const randomBytes = CryptoJS.lib.WordArray.random(32);
  return CryptoJS.enc.Base64.stringify(randomBytes)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function generateCodeChallenge(codeVerifier) {
  const hash = CryptoJS.SHA256(codeVerifier);
  return CryptoJS.enc.Base64.stringify(hash)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export default {
  state: {
    isAuthenticated: !!localStorage.getItem("access_token"),
    authToken: localStorage.getItem("access_token"),
  },

  getters: {
    isAuthenticated: (state) => {
      const token = state.authToken || localStorage.getItem("access_token");
      if (token) {
        if (token.split(".").length === 3) {
          try {
            var base64Url = token.split(".")[1];
            var base64 = base64Url.replace("-", "+").replace("_", "/");
            var exp = JSON.parse($window.atob(base64)).exp;
            if (typeof exp === "number") {
              return Math.round(new Date().getTime() / 1000) < exp;
            }
          } catch (e) {
            return true;
          }
        }
        return true;
      }
      return false;
    },
    authToken: (state) => state.authToken,
  },

  mutations: {
    SET_AUTH(state, token) {
      state.authToken = token;
      state.isAuthenticated = !!token;
      if (token) {
        localStorage.setItem("access_token", token);
      } else {
        localStorage.removeItem("access_token");
      }
    },
  },

  actions: {
    login() {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = generateCodeChallenge(codeVerifier);

      localStorage.setItem("code_verifier", codeVerifier);

      const authUrl = `${AUTHORIZE_ENDPOINT}?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
        REDIRECT_URI
      )}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

      window.location.href = authUrl;
    },

    async handleCallback({ commit }) {
      console.log("Handling OAuth callback...");
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const codeVerifier = localStorage.getItem("code_verifier");

      if (!code || !codeVerifier) {
        console.error("Code ou code_verifier manquant !");
        return;
      }

      try {
        const response = await axios.post(
          TOKEN_ENDPOINT,
          {
            grant_type: "authorization_code",
            client_id: CLIENT_ID,
            redirect_uri: REDIRECT_URI,
            code,
            code_verifier: codeVerifier,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        commit("SET_AUTH", response.data.access_token);

        Swal.close();

        router.push("/dashboard");
      } catch (error) {
        console.error("Erreur d'authentification :", error);
      }
    },

    logout({ commit }) {
      commit("SET_AUTH", null);
      // router.push({ name: "Login" });

      localStorage.clear();
      location = AUTH_SERVER_HOME_PAGE
    },
  },
};
